import { Stack, Title } from '@mantine/core';

import { formatOrganizationTitle } from '../../utils/stringUtils';
import useOrgPermissions from '../../hooks/useOrgPermissions';
import { ResourceList } from '../../components';

const Resources: React.FC = () => {
  const { organizationName } = useOrgPermissions();

  const title = (
    <Title ta={'start'} order={6} >
      {formatOrganizationTitle(organizationName ?? '', 'Resources')}
    </Title>
  );
  return (
    <Stack
      flex={1}
      gap={0}
      mt={12}
    >
      <ResourceList
        title={title}
        allowResourceUpload
      />
    </Stack>
  );
};

export default Resources;
